// import React, { useState } from "react";
// import { Popover, Space } from "antd";
// import { useTranslation } from "react-i18next";

// import { BsCheckLg } from "react-icons/bs";

// export default function QualityItem({ quality, changeQuality }) {
//   const [selected, setSelected] = useState(-1);
//   const { t, i18n } = useTranslation();

//   const handleSelected = (indx) => {
//     setSelected(indx);
//   };

//   const listStyle = {
//     paddingInline: "1rem",
//     paddingBlock: ".20rem",
//   };

//   const qualityContent = (
//     <ul className="setting-list-wrapper" key={quality.id}>
//       <li
//         role="button"
//         style={listStyle}
//         onClick={() => {
//           changeQuality(-1);
//           handleSelected(-1);
//         }}
//       >
//         {selected === -1 ? (
//           <BsCheckLg size={20} style={{ marginInlineEnd: "0.5rem" }} />
//         ) : null}
//         {t("auto")}
//       </li>
//       {quality?.options?.map((option, index) => {
//         return (
//           <li
//             style={listStyle}
//             onClick={() => {
//               changeQuality(option.index);
//               handleSelected(option.index);
//             }}
//             key={option.id}
//             role="button"
//           >
//             {selected === option.index ? (
//               <BsCheckLg size={20} style={{ marginInlineEnd: "0.5rem" }} />
//             ) : null}
//             {`${option.height}p`}
//           </li>
//         );
//       })}
//     </ul>
//   );

//   return (
//     <Popover
//       content={qualityContent}
//       placement="topLeft"
//       title={quality.title}
//       key={quality.id}
//       //   trigger="click"
//       trigger="hover"
//       showArrow={false}
//       //   getPopupContainer={() => videoFullScreenWrapper?.current}
//       // overlayStyle={{ position: "fixed", zIndex: "99999" }}
//     >
//       <Space align="center" role="button">
//         <span className="mock-block">
//           <img src={quality.icon} alt="" />
//         </span>
//         <span
//           className="mock-block"
//           style={{
//             color: "#fff",
//           }}
//         >
//           {t(quality.title)}
//         </span>
//       </Space>
//     </Popover>
//   );
// }

import React, { useState } from "react";
import { Space } from "antd";
import { useTranslation } from "react-i18next";
import { BsCheckLg } from "react-icons/bs";

export default function QualityItem({
  quality,
  changeQuality,
  selectedQuality,
  setSelectedQuality,
}) {
  // const [selected, setSelected] = useState(-1);
  const [isListVisible, setIsListVisible] = useState(false);

  const { t, i18n } = useTranslation();

  // const handleSelected = (indx) => {
  //   setSelectedQuality(indx);
  // };

  const qualityStyle = {
    // paddingInline: ".5rem",
    // paddingBlock: ".25rem",
    padding: "0.5rem",
    display: "flex",
    color: "#fff",
    width: "100%",
  };

  const qualityContent = (
    <ul
      //   className="setting-list-wrapper"
      onMouseLeave={() => setIsListVisible(!isListVisible)}
      key={quality.id}
      style={{
        width: "130px",
        position: "absolute",
        bottom: "30px",
        background: "rgba(0, 0,0, .5)",
        color: "#fff",
        zIndex: 1000,
        listStyle: "none",
        padding: 0,
        margin: 0,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
      }}
    >
      <li
        role="button"
        style={qualityStyle}
        onClick={() => {
          changeQuality(-1);
          setSelectedQuality(-1);
          setIsListVisible(false);
        }}
      >
        {selectedQuality === -1 ? (
          <BsCheckLg size={20} style={{ marginInlineEnd: "0.5rem" }} />
        ) : null}
        {t("auto")}
      </li>
      {quality?.options?.map((option) => (
        <li
          key={option.index}
          style={qualityStyle}
          onClick={() => {
            changeQuality(option.index);
            setSelectedQuality(option.index);
            setIsListVisible(false);
          }}
          role="button"
        >
          {selectedQuality === option.index ? (
            <BsCheckLg size={20} style={{ marginInlineEnd: "0.5rem" }} />
          ) : null}
          {`${option.height}p`}
        </li>
      ))}
    </ul>
  );

  return (
    <div
      style={{ position: "relative" }}
      onClick={() => setIsListVisible(!isListVisible)}
      //   onMouseLeave={() => setIsListVisible(!isListVisible)}
    >
      <Space align="center" role="button">
        <span className="mock-block">
          <img src={quality.icon} alt="" />
        </span>
        <span
          className="mock-block"
          style={{
            color: "#fff",
          }}
        >
          {t(quality.title)}
        </span>
      </Space>
      {isListVisible && qualityContent}
    </div>
  );
}
